/*
 * SimpleTableHeader.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Mar 02 2023 mys Company
 */

const DateTableCells = ({ items, dateLocalize = 'fa-IR' }) => {
    return (
        <>
            {items &&
                items.map((item, index) => {
                    return <td key={index}>{item ? new Date(item).toLocaleDateString(dateLocalize) : '-'}</td>
                })}
        </>
    )
}

export default DateTableCells
